"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_STYLES = exports.ICON_DIMENSION = void 0;
// styled components
var ICON_DIMENSION = exports.ICON_DIMENSION = 28;
var ICON_STYLES = exports.ICON_STYLES = "\n  display: inline-block;\n  height: ".concat(ICON_DIMENSION, "px;\n  vertical-align: top;\n  width: ").concat(ICON_DIMENSION, "px;\n");